import Vue from "vue";
import { createTemplateApp } from "@/createTemplateApp";

Vue.prototype.$_variant_modal_button = "v1"; //TODO: нужен файл настройки для таких вещей!
Vue.prototype.$_variant_outline_button = "v3";
Vue.prototype.$_color_auth_preloader = true;

import "@/settings/additional";
import "@/settings/modals";
import "@zavtra/sprites";

import ThePreloader from "@zavtra/components/ThePreloader";
Vue.component("preloader", ThePreloader);

import App from "./App";
import zavtraConfig from "./config";
import { zavtraMeta } from "./meta";
import { zavtraRouter } from "./router";

Vue.config.productionTip = false;

export const createApp = (context) => {
    return createTemplateApp({
        context,
        renderApp: App,
        config: zavtraConfig,
        metaList: zavtraMeta,
        routerList: zavtraRouter,
    });
};
